import featureFlagStore from "./featureFlagStore";
import { useShallow } from "zustand/react/shallow";

const useFeatureFlagStore = () => {
  const { enableOnlineAuction, isLoaded, fetchFeatureFlags } = featureFlagStore(
    useShallow((state) => ({
      enableOnlineAuction: state.enableOnlineAuction,
      isLoaded: state.isLoaded,
      fetchFeatureFlags: state.fetchFeatureFlags,
    }))
  );

  return { enableOnlineAuction, isLoaded, fetchFeatureFlags };
};

export default useFeatureFlagStore;
